import {WinForm} from "@/libs";

const driveModel = Symbol("driveModel");

export class DownloadService {
  //驱动模型
  static driveModelMx(args: any, callback: Function) {
    this[driveModel](args, "Mx", callback);
  }

  //驱动step格式模型
  static driveModelStep(args: any, callback: Function) {
    this[driveModel](args, "Step", callback);
  }

  //驱动模型的公共处理
  static [driveModel](args: any, type: any, callback: Function) {
    //模型驱动
    type == "Mx" ? WinForm.tools.driveModel(args, (state: string) => {
      callback(state);
    }) : (WinForm.tools.driveStep(args), callback("success"));
  }
}




